<template>
  <v-card outlined v-bind="$attrs">
    <v-card-title>
      Public Register Preview

      <v-spacer />
      <v-btn icon @click="getPerson">
        <v-icon>
          refresh
        </v-icon>
      </v-btn>
    </v-card-title>
    <v-card-subtitle v-if="notFound">
      Preview not available
    </v-card-subtitle>

    <div v-if="!personId">
      ID not supplied
    </div>

    <v-progress-linear v-if="loading" indeterminate />

    <v-simple-table class="results" v-if="person.reg_num">
      <thead>
        <tr>
          <th colspan="2">
            {{ person.fullname }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Registration No</td>
          <td>{{ person.reg_num }}</td>
        </tr>
        <tr>
          <td>Qualifications</td>
          <td>{{ person.quals }}</td>
        </tr>
        <tr>
          <td>Date of Registration</td>
          <td>{{ person.regdate }}</td>
        </tr>
        <tr>
          <td>Work Address</td>
          <td>
            <span v-if="person.workname">
              {{ person.workname }}
            </span>

            <br
              v-if="person.workname && person.workaddress != 'Not Supplied'"
            />

            <span
              v-if="!person.workname || person.workaddress != 'Not Supplied'"
            >
              {{ person.workaddress }}
            </span>
          </td>
        </tr>
        <tr>
          <td>Status<sup>1</sup></td>
          <td>{{ person.status }}</td>
        </tr>
        <tr>
          <td>Conditions on Scope of Practice</td>
          <td>{{ person.conditions }}</td>
        </tr>
        <tr>
          <td>Scopes of Practice</td>
          <td>{{ person.scopeofpractice }}</td>
        </tr>
        <tr>
          <td>Region</td>
          <td>{{ person.region }}</td>
        </tr>
        <tr>
          <td>HPI</td>
          <td>{{ person.hpi }}</td>
        </tr>
      </tbody>
    </v-simple-table>
  </v-card>
</template>

<script>
export default {
  name: "PublicRegisterPreview",
  data() {
    return {
      notFound: false,
      loading: false,
      person: {}
    };
  },
  props: {
    personId: {
      type: [String, Number],
      required: true,
      default: null
    }
  },
  watch: {
    personId: { immediate: true, handler: "getPerson" }
  },
  methods: {
    async getPerson() {
      if (!this.personId) {
        return;
      }
      try {
        this.notFound = false;
        this.loading = true;
        let res = await this.$http.get("register/public", {
          params: { search: this.personId }
        });
        if (res.data.listings.length) {
          this.person = {
            ...res.data.listings.filter(p => p.id == this.personId)[0]
          };
        } else {
          this.notFound = true;
        }
      } catch (e) {
        this.notFound = true;
      } finally {
        this.loading = false;
      }
    },
    async refresh() {
      this.getPerson();
    }
  }
};
</script>
